module.exports = __webpack_public_path__ + "static/media/Education.033fd05c.png";